<template>
    <div class="w-full h-full flex flex-col" v-if="this.loaded">
        <main ref="notescontainer" class="flex-1 overflow-x-auto overflow-y-scroll pr-2">
            <div v-for="note in notes" :key="note.id"
                 class="flex-1 flex flex-col w-full border-t border-b overflow-visible z-10 "
                 :class="(isPinned(note)?' sticky bg-gray-50 top-0 bottom-0 border-gray-200 ':'border-transparent') + (lastClicked == note?' z-30':' hover:z-20')"
                 :style="'top:'+(note.topPinnedAt*2)+'rem; bottom:'+(note.bottomPinnedAt*2)+'rem'">
                <div class="max-w-md my-2 ml-2" :class="(isYou(note) ? 'ml-8 self-end' : 'mr-8 self-start')">
                    <div class="rounded-xl border p-3 flex flex-row last:mb-0 max-w-md"
                         :class="isYou(note)? 'bg-brand border-brand-dark text-white': 'bg-gray-50 border-gray-300 text-brand'">
                        <div class="mr-3 flex-shrink-0 text-center">
                            <img class="rounded h-6 w-6"
                                 :src="'/img/user-placeholder.png'"
                                 onerror="this.src='/img/user-placeholder.png';this.onerror='';"/>
                            <ui-dropdown menu-class="p-3 w-56" :close-on-mouse-out-scroll="true"
                                         @closed="lastClicked = false">
                                <template #default="{ toggle }">
                                    <button @click="() => { toggle(); click(note)}"
                                            class="text-gray-300 hover:text-gray-500 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-600 relative rounded">
                                        <i class="fa fa-ellipsis-h"></i>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <ui-dropdown-item icon="fas fa-thumbtack" @click="pinNote(note); close()"
                                                      v-if="!isPinned(note)">
                                        Pin Note
                                    </ui-dropdown-item>
                                    <ui-dropdown-item icon="fas fa-thumbtack" @click="unpinNote(note); close()"
                                                      v-if="isPinned(note)">
                                        Un-Pin Note
                                    </ui-dropdown-item>
                                </template>
                            </ui-dropdown>
                        </div>
                        <div>
                            <h3 class="text-xs font-bold" :class="isYou(note) ? 'text-white' : 'text-gray-700'"
                                v-text="note.createdBy"></h3>
                            <div class="whitespace-pre-wrap"
                                 :class="isYou(note) ? 'text-white' : 'text-gray-700'" v-text="note.text"></div>
                        </div>
                    </div>
                    <div :class="isYou(note) ? 'text-right' : 'text-left'" class="mt-1.5 text-xs">
                    <span class="inline-block text-gray-400 hover:text-gray-500 cursor-pointer" @click="toggleShowHuman"
                          :title="showHuman?moment(note.createdOn).format('Do MMMM YYYY, h:mm a'):note.createdAtHuman">{{
                            showHuman ? note.createdAtHuman : moment(note.createdOn).format('Do MMMM YYYY, h:mm a')
                        }}</span>
                    </div>
                </div>
            </div>
        </main>

        <aside class="mt-6">
            <div class="mt-1 flex rounded-md shadow-sm">
                <div class="relative flex items-stretch flex-grow focus-within:z-10 ml-px mb-px">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <img class="rounded w-6 h-6"
                             :src="'/img/user-placeholder.png'"
                             onerror="this.src='/img/user-placeholder.png';this.onerror='';"/>
                    </div>
                    <input
                        v-model="note"
                        type="text"
                        class="focus:ring-brand focus:border-brand block w-full mb-0 rounded-none rounded-l-md pl-12 sm:text-sm border-gray-300"
                        placeholder="Enter note here..."
                        @keyup.enter="addNote()">
                </div>
                <button @click.prevent="addNote()"
                        class="-ml-px mb-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md bg-gray-50 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand"
                        :class="!note?'text-gray-300 cursor-not-allowed':'text-gray-700 hover:bg-gray-100'">
                    <i class="fas fa-caret-right"></i>
                    <span>Send</span>
                </button>
            </div>
        </aside>
    </div>
</template>

<script>
import User from "../services/User";
import UiDropdownItem from "./ui/UiDropdownItem.vue";
import UiDropdownDivider from "./ui/UiDropdownDivider.vue";
import remoteStorage from "../utils/remoteStorage";
import moment from "moment";

export default {
    components: {UiDropdownDivider, UiDropdownItem},
    props: {
        "getUrl": String,
        "postUrl": String,
        "pinUrl": String,
        "unpinUrl": String,
    },
    data() {
        return {
            notes: [],
            note: '',
            user: false,
            loaded: false,
            lastClicked: false,
            showHuman: true,
        }
    },
    watch: {},
    computed: {
        moment() {
            return moment
        },
        avatar_url() {
            return appData.user.avatar_url;
        }
    },
    methods: {
        toggleShowHuman() {
            this.showHuman = !this.showHuman;
            remoteStorage.setItem('notes-show-human', JSON.stringify(this.showHuman));
        },
        click(note) {
            this.lastClicked = note
        },
        scrollToBottom() {
            this.$nextTick(() => {
                let container = this.$refs.notescontainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            })
        },
        async addNote() {
            if (this.note) {
                await Http.post(this.postUrl, {text: this.note})
                this.note = '';
                await this.getNotes();
                this.scrollToBottom()
            }
        },
        isYou(note) {
            return note.createdByReference === this.user.id
        },
        isPinned(note) {
            return note.pinned
        },
        async pinNote(note) {
            note.pinned = true
            await Http.post(this.postUrl, note)
            await this.getNotes()
        },
        async unpinNote(note) {
            note.pinned = false
            await Http.post(this.postUrl, note)
            await this.getNotes()
        },
        async getNotes() {
            let notes = await Http.get(this.getUrl);
            let ret = 0;
            notes.forEach((i) => {
                if (this.isPinned(i)) {
                    i.topPinnedAt = ret++;
                }
            })
            notes.forEach((i) => {
                if (this.isPinned(i)) {
                    i.bottomPinnedAt = --ret;
                }
            })
            this.notes = notes;
        },
    },
    async mounted() {
        await User.register()
        await this.getNotes()
        this.user = User.user
        this.showHuman = remoteStorage.getItem('notes-show-human', true, true)
        this.loaded = true;
        this.scrollToBottom();
    }
}
</script>
